module.exports = __webpack_public_path__ + "bariol_regular_italic-webfont.asset.12e3d58303ada25fc15aa39c72356dae.woff";